module.exports = __webpack_public_path__ + "static/img/1e588bb09941b91ae729622c2a7e9b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_04.png
// module id = v51N
// module chunks = 1